module.exports = __webpack_public_path__ + "img/logo.0279a9e8.png";